import {Link, useParams} from "react-router";
import {useEffect, useState} from "react";

import * as DateTime from '../utilities/dateTime';

function User() {
    const params = useParams()
    const [user, setUser] = useState(null);
    const [entryTemplates, setEntryTemplates] = useState([]);

    const [entryTemplateStructureMessage, setEntryTemplateStructureMessage] = useState('');
    const [entryTemplateStructureLoading, setEntryTemplateStructureLoading] = useState(false);
    const [templateSort, setTemplateSort] = useState({
      key: 'category',
      direction: 'asc',
    });
    const [duplicateTemplate, setDuplicateTemplate] = useState(null);
    const [duplicateYear, setDuplicateYear] = useState('');
    const duplicateYears = Array.from({length: new Date().getFullYear() - 2019}, (_, index) => 2020 + index);

    useEffect(() => {
      getUser().then();
      document.title = 'FeelingHealth - User';
    }, []);

    useEffect(() => {
      getEntryTemplates().then();
      // getEntryTags();
    }, [user])


    const getUser = async () => {
      // console.log('getUser');

      const response = await fetch(process.env.REACT_APP_BRAIN_HOST + '/user/' + params.userId,{
        credentials: "include",
      });
      // console.log('getUser response', response);
      // console.log('response body', await response.json());

      if (!response.ok) {
        console.error('Error getting user:', response.statusText);
        return;
      }

      const myUser = await response.json();
      setUser(myUser);
    };

    const getEntryTemplates = async () => {
        console.log('getEntryTemplates');

        if (!user) {
            return;
        }

        const url = new URL('/entryTemplates', process.env.REACT_APP_BRAIN_HOST);
        url.searchParams.set('uid', user._id);

        const response = await fetch(url.toString(), {
          credentials: "include",
        });
        const myEntryTemplates = await response.json();

        console.log('myEntryTemplates', myEntryTemplates);
        setEntryTemplates(myEntryTemplates);

    };

    const deleteEntryTemplatesNumDuplicates = async (entry_template_id, confirm_delete = false) => {
      console.log('deleteEntryTemplatesNumDuplicates', entry_template_id);

      const url = new URL('/entryTemplates/' + entry_template_id + '/deleteDuplicates', process.env.REACT_APP_BRAIN_HOST);
      url.searchParams.set('uid', user._id);
      url.searchParams.set('confirm_delete', confirm_delete);
      if (duplicateYear) {
        url.searchParams.set('year', duplicateYear);
      }

      const response = await fetch(url.toString(), {
        credentials: "include",
      });

      const dupSummary = await response.json();

      setEntryTemplates(currentTemplates => currentTemplates.map(et => {
        if (et._id === entry_template_id) {
          // Keep results tied to the requested year, including responses arriving after a selection change.
          return {...et, duplicateSummary: dupSummary, duplicateSummaryYear: duplicateYear}
        } else {
          return et;
        }
      }));
    }

    const downloadCsv = (csv, filename) => {
      const blob = new Blob([csv], {type: 'text/csv;charset=utf-8'});
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(blob);
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(a.href);
      a.remove();
    };

    const getEntryTemplateStructure = async event => {
      event.preventDefault();
      setEntryTemplateStructureMessage('');

      if (entryTemplateStructureLoading) {
        return;
      }

      if (!user) {
        setEntryTemplateStructureMessage('User is still loading.');
        return;
      }

      setEntryTemplateStructureLoading(true);

      try {
        const url = new URL('/getEntryTemplateStructure', process.env.REACT_APP_BRAIN_HOST);
        url.searchParams.set('uid', user._id);

        const response = await fetch(url.toString(), {
          credentials: "include",
        });

        if (!response.ok) {
          throw new Error('Unable to get entry template structure');
        }

        const responseData = await response.json();
        if (!responseData.is_csv) {
          setEntryTemplateStructureMessage('Entry template structure response was not a CSV.');
          return;
        }

        if (!responseData.tags_combined_by_template_csv_data || !responseData.tags_split_by_combination_csv_data) {
          setEntryTemplateStructureMessage('Entry template structure CSV was empty.');
          return;
        }

        downloadCsv(
          responseData.tags_combined_by_template_csv_data,
          'entry-template-tags-combined-by-template.csv'
        );
        downloadCsv(
          responseData.tags_split_by_combination_csv_data,
          'entry-template-tags-split-by-combination.csv'
        );
      } catch (error) {
        setEntryTemplateStructureMessage(error.message);
      } finally {
        setEntryTemplateStructureLoading(false);
      }
    };

    const Content = () => {

        // const ActionSummary = () => {
        //
        //     const generateActionSummary = () => {
        //         fetch(process.env.REACT_APP_BRAIN_HOST + '/generateActionSummary?_partition=' + user._partition,
        //             {headers: new Headers({
        //                     'Heart-Secret-Key': process.env.REACT_APP_HEART_SECRET_KEY,
        //                 })}
        //         )
        //             .then(response => response.json())
        //             .then(
        //                 result => {
        //                     console.log('r', result);
        //                 },
        //                 error => {
        //                     console.log('e', error);
        //                 }
        //             );
        //     };
        //
        //     return (
        //         <div style={{marginTop: '20px'}}>
        //             <h2>Action Summary</h2>
        //             <button onClick={() => generateActionSummary()}>Generate Action Summary</button>
        //             <div>
        //                 <span>No summary for today</span>
        //             </div>
        //         </div>
        //     );
        // };

        const confirmDeleteDuplicates = async template => {
          console.log('confirmDeleteDuplicates', template);

          if (window.confirm("Are you sure you want to delete " + template.duplicateSummary.numDuplicates
            + " duplicate templates? This cannot be undone!")) {
            await deleteEntryTemplatesNumDuplicates(template._id, true);
            setDuplicateTemplate(null);
          }
        };

        const EntryTemplates = () => {

          console.log('loading EntryTemplates content');

            if (!entryTemplates.length) {
                return (
                    <div>
                        <h3>Templates</h3>
                        <span>Getting templates...</span>
                    </div>
                );
            }

            const getTemplateDate = (template, key) => {
              const value = template[key];
              return value ? new Date(value) : null;
            };

            const formatTemplateDate = (template, key, showTime = false) => {
              const date = getTemplateDate(template, key);
              if (!date || Number.isNaN(date.getTime())) {
                return '...';
              }

              const dateText = DateTime.getPlainTextDate(date);
              if (!showTime) {
                return dateText;
              }

              return `${dateText} ${DateTime.getPlainTextTime(date)}`;
            };

            const getSortValue = (template, key) => {
              if (key === 'created_date' || key === 'last_used_date') {
                const date = getTemplateDate(template, key);
                return date && !Number.isNaN(date.getTime()) ? date.getTime() : 0;
              }

              return (template[key] || '').toString().toLowerCase();
            };

            const compareTemplates = (a, b, key, direction) => {
              const firstValue = getSortValue(a, key);
              const secondValue = getSortValue(b, key);
              const directionMultiplier = direction === 'asc' ? 1 : -1;

              let result = 0;
              if (typeof firstValue === 'number' && typeof secondValue === 'number') {
                result = firstValue - secondValue;
              } else {
                result = firstValue.localeCompare(secondValue);
              }

              if (result !== 0) {
                return result * directionMultiplier;
              }

              const categoryResult = getSortValue(a, 'category').localeCompare(getSortValue(b, 'category'));
              if (categoryResult !== 0) {
                return categoryResult;
              }

              return getSortValue(a, 'name').localeCompare(getSortValue(b, 'name'));
            };

            const sortTemplates = key => {
              setTemplateSort(currentSort => ({
                key,
                direction: currentSort.key === key && currentSort.direction === 'asc' ? 'desc' : 'asc',
              }));
            };

            const SortHeader = ({ sortKey, children }) => {
              const isActive = templateSort.key === sortKey;
              const sortLabel = isActive ? (templateSort.direction === 'asc' ? ' ▲' : ' ▼') : '';

              return (
                <button
                  type="button"
                  onClick={() => sortTemplates(sortKey)}
                  style={{
                    border: 0,
                    background: 'transparent',
                    padding: 0,
                    color: 'inherit',
                    cursor: 'pointer',
                    font: 'inherit',
                    fontWeight: 600,
                    textAlign: 'left',
                  }}
                >
                  {children}{sortLabel}
                </button>
              );
            };

            const DedupEntries = ({ template }) => {
              // console.log('Dedup entries', template);

              if (!template.duplicateSummary || template.duplicateSummaryYear !== duplicateYear) {
                // Haven't done anything yet
                return (
                  <a href='#!'
                     onClick={event => {
                       event.preventDefault();
                       deleteEntryTemplatesNumDuplicates(template._id, false);
                     }}>
                    Count Duplicates
                  </a>
                );
              }

              if (template.duplicateSummary.dry_run) {
                // Just getting the info about how many duplicates there are
                return (
                  <div>
                    <span>{template.duplicateSummary.numDuplicates} duplicates</span>
                    {template.duplicateSummary.numDuplicates > 0 ? (
                      <a href='#!' style={{marginLeft: '10px'}}
                         onClick={event => {
                           event.preventDefault();
                           setDuplicateTemplate(template);
                         }}>
                        View entries to delete
                      </a>
                    ) : null}
                  </div>
                );
              }

              if (template.duplicateSummary.error) {
                // There was an error deleting duplicates
                return (
                  <div>
                    <span
                      style={{
                        color: "#b00",
                        fontSize: "12px",
                        display: "block",
                        marginLeft: "10px",
                      }}
                    >
                      Error: {template.duplicateSummary.error}
                      <br />
                      Template: {template.duplicateSummary.entry_template_id}
                      <br />
                      Deleted: {template.duplicateSummary.num_duplicates_deleted}
                    </span>
                    <a href='#!' style={{marginLeft: '10px'}}
                       onClick={event => {
                         event.preventDefault();
                         deleteEntryTemplatesNumDuplicates(template._id, false);
                       }}>
                      Count Duplicates
                    </a>
                  </div>
                );
              }

              // Deleted entries for real
              return (
                <div>
                  <span style={{color: '#0b0'}}>
                    Deleted {template.duplicateSummary.numDuplicates} duplicates
                  </span>
                  <a href='#!' style={{marginLeft: '10px'}}
                     onClick={event => {
                       event.preventDefault();
                       deleteEntryTemplatesNumDuplicates(template._id, false);
                     }}>
                    Count Duplicates
                  </a>
                </div>
              );

            };

            const TemplateActions = ({ template }) => {
              return (
                <div style={{display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'flex-start'}}>
                  <DedupEntries template={template} />
                </div>
              );
            };

            let templates = [...entryTemplates];
            templates.sort((a, b) => compareTemplates(a, b, templateSort.key, templateSort.direction));

            return (
                <div>
                    <h2>Templates ({entryTemplates.length})</h2>
                    <div style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px'}}>
                      <label htmlFor="duplicate-year">Duplicate year</label>
                      <select
                        id="duplicate-year"
                        value={duplicateYear}
                        onChange={event => {
                          setDuplicateYear(event.target.value);
                          setDuplicateTemplate(null);
                        }}
                      >
                        <option value="">All</option>
                        {duplicateYears.map(year => <option key={year} value={year}>{year}</option>)}
                      </select>
                    </div>
                    <table style={{
                      width: '100%',
                      borderCollapse: 'collapse',
                      marginTop: '10px',
                    }}>
                      <thead>
                        <tr>
                          <th style={{borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left'}}>
                            <SortHeader sortKey="category">Category</SortHeader>
                          </th>
                          <th style={{borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left'}}>
                            <SortHeader sortKey="name">Template Name</SortHeader>
                          </th>
                          <th style={{borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left'}}>
                            <SortHeader sortKey="created_date">Created</SortHeader>
                          </th>
                          <th style={{borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left'}}>
                            <SortHeader sortKey="last_used_date">Last Used</SortHeader>
                          </th>
                          <th style={{borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left'}}>
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {templates.map(template => (
                          <tr key={template._id}>
                            <td style={{borderBottom: '1px solid #eee', padding: '8px', verticalAlign: 'top'}}>
                              {template.category || '...'}
                            </td>
                            <td style={{borderBottom: '1px solid #eee', padding: '8px', verticalAlign: 'top'}}>
                              <Link to={'template/' + template._id}>
                                {template.ended_by_entry_template_id ? (
                                  <span>Start: </span>
                                ) : null}
                                {template.name}
                              </Link>
                              <div style={{color: '#777', fontSize: '12px', marginTop: '2px'}}>
                                {template._id}
                              </div>
                            </td>
                            <td style={{borderBottom: '1px solid #eee', padding: '8px', verticalAlign: 'top'}}>
                              {formatTemplateDate(template, 'created_date')}
                            </td>
                            <td style={{borderBottom: '1px solid #eee', padding: '8px', verticalAlign: 'top'}}>
                              {formatTemplateDate(template, 'last_used_date', true)}
                            </td>
                            <td style={{borderBottom: '1px solid #eee', padding: '8px', verticalAlign: 'top'}}>
                              <TemplateActions template={template} />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                </div>
            );
        };

        const DuplicateEntriesModal = () => {
          if (!duplicateTemplate) {
            return null;
          }

          const duplicateSummary = duplicateTemplate.duplicateSummary;
          const duplicates = duplicateSummary?.first_100_duplicates || [];
          const columns = duplicates.reduce((prev, duplicate) => {
            Object.keys(duplicate || {}).forEach(key => {
              if (!prev.includes(key)) {
                prev.push(key);
              }
            });
            return prev;
          }, []).sort((a, b) => {
            const isDuplicateOfEntryId = key => key.replace(/[^a-z0-9]/gi, '').toLowerCase() === 'duplicateofentryid';

            if (isDuplicateOfEntryId(a)) {
              return 1;
            }

            if (isDuplicateOfEntryId(b)) {
              return -1;
            }

            return 0;
          });

          const getDuplicateValue = (duplicate, key) => {
            const value = duplicate[key];
            if (value === null || value === undefined) {
              return '...';
            }

            if (key.toLowerCase().includes('date')) {
              const date = new Date(value);
              if (!Number.isNaN(date.getTime())) {
                return `${DateTime.getPlainTextDate(date)} ${DateTime.getPlainTextTime(date)}`;
              }
            }

            if (typeof value === 'object') {
              return JSON.stringify(value);
            }

            return value.toString();
          };

          return (
            <div
              onClick={() => setDuplicateTemplate(null)}
              style={{
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                background: 'rgba(0, 0, 0, 0.35)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000,
              }}
            >
              <div
                onClick={event => event.stopPropagation()}
                style={{
                  width: 'min(880px, calc(100vw - 40px))',
                  maxHeight: 'calc(100vh - 80px)',
                  overflow: 'auto',
                  background: '#fff',
                  borderRadius: '6px',
                  boxShadow: '0 12px 40px rgba(0, 0, 0, 0.25)',
                  padding: '20px',
                }}
              >
                <div style={{display: 'flex', justifyContent: 'space-between', gap: '20px', alignItems: 'start'}}>
                  <div>
                    <h3 style={{margin: 0}}>Duplicate Entries To Delete</h3>
                    <div style={{color: '#777', fontSize: '13px', marginTop: '4px'}}>
                      {duplicateTemplate.name}
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => setDuplicateTemplate(null)}
                    style={{
                      border: '1px solid #ccc',
                      background: '#fff',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      padding: '4px 8px',
                    }}
                  >
                    Close
                  </button>
                </div>
                <div style={{marginTop: '12px'}}>
                  Showing first {duplicates.length} of {duplicateSummary.numDuplicates} duplicates.
                </div>
                {duplicates.length && columns.length ? (
                  <table style={{width: '100%', borderCollapse: 'collapse', marginTop: '12px'}}>
                    <thead>
                      <tr>
                        {columns.map(column => (
                          <th
                            key={column}
                            style={{borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left'}}
                          >
                            {column}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {duplicates.map((duplicate, key) => (
                        <tr key={duplicate.entry_id || duplicate._id || key}>
                          {columns.map(column => (
                            <td
                              key={column}
                              style={{borderBottom: '1px solid #eee', padding: '8px', verticalAlign: 'top'}}
                            >
                              {getDuplicateValue(duplicate, column)}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div style={{color: '#777', marginTop: '12px'}}>
                    No duplicate entries returned.
                  </div>
                )}
                <div style={{borderTop: '1px solid #eee', marginTop: '16px', paddingTop: '16px'}}>
                  <button
                    type="button"
                    onClick={() => confirmDeleteDuplicates(duplicateTemplate)}
                    style={{
                      border: '1px solid #b00',
                      background: '#b00',
                      color: '#fff',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      padding: '6px 10px',
                    }}
                  >
                    Delete all {duplicateSummary.numDuplicates} duplicates
                  </button>
                </div>
              </div>
            </div>
          );
        };

        return (
            <div>
                <div style={{clear: 'both'}}>
                    <EntryTemplates />
                </div>
                <DuplicateEntriesModal />
            </div>

        );
    };

    return (
        <div style={{padding: '20px', marginBottom: '20px'}}>
          <div>
            <Link to={`/`}>Back to Dashboard</Link>
            <span style={{margin: '0 8px'}}>|</span>
            <a
              href='#!'
              onClick={getEntryTemplateStructure}
              style={{
                color: entryTemplateStructureLoading ? '#777' : undefined,
                pointerEvents: entryTemplateStructureLoading ? 'none' : undefined,
              }}
            >
              {entryTemplateStructureLoading ? 'Downloading Entry Template Structure...' : 'Download Entry Template Structure'}
            </a>
          </div>
          {entryTemplateStructureMessage.length ? (
            <div style={{color: '#b00', marginTop: '5px'}}>
              {entryTemplateStructureMessage}
            </div>
          ) : null}
          <span>Firestore User: {user ? user._id : 'Loading...'}</span>
          {user ? <Content /> : null}
        </div>
    );
}

export default User;
